const AdapterForwardedFromHeader = "X-Adapter-Forwarded-From";
var AdapterForwardedFromValues = /* @__PURE__ */ ((AdapterForwardedFromValues2) => {
  AdapterForwardedFromValues2["vCurrent"] = "vCurrent";
  AdapterForwardedFromValues2["vNext"] = "vNext";
  return AdapterForwardedFromValues2;
})(AdapterForwardedFromValues || {});
var ApprovalEntityType = /* @__PURE__ */ ((ApprovalEntityType2) => {
  ApprovalEntityType2["progression"] = "progression";
  ApprovalEntityType2["progressionStage"] = "progression stage";
  ApprovalEntityType2["override"] = "custom override";
  ApprovalEntityType2["emergencyOverride"] = "emergency override";
  ApprovalEntityType2["progressionStep"] = "progression step";
  return ApprovalEntityType2;
})(ApprovalEntityType || {});
var ConfigProviderMigrationState = /* @__PURE__ */ ((ConfigProviderMigrationState2) => {
  ConfigProviderMigrationState2["new"] = "New";
  ConfigProviderMigrationState2["migrating"] = "Migrating";
  ConfigProviderMigrationState2["migrationSucceeded"] = "MigrationSucceeded";
  ConfigProviderMigrationState2["migrationFailed"] = "MigrationFailed";
  return ConfigProviderMigrationState2;
})(ConfigProviderMigrationState || {});
export {
  AdapterForwardedFromHeader,
  AdapterForwardedFromValues,
  ApprovalEntityType,
  ConfigProviderMigrationState
};
//# sourceMappingURL=FeatureApiModel.js.map
